import React, { FunctionComponent } from 'react';

import { useGetPartnersQuery } from 'src/api/@generated/backend-api';

import { useFetchTokenMutation } from 'src/api/authentication-api/authentication-api';
import { PartnerLogo } from 'src/components/partner-logo';
import { config } from 'src/config/config';
import { selectSelectedAccount } from 'src/state/account/selectors';
import { useAppSelector } from 'src/state/thunk-api';
import { PartnerUtils } from 'src/utils/partner-utils';
import { i18n } from 'src/i18n';

import { FooterCustomerInformation } from './footer-customer-information';
import { FooterExternalLink } from './footer-external-link';
import { StyledFooter, StyledLinks, StyledLogoAndLinksContainer } from './footer.styled';

const Footer: FunctionComponent = () => {
  const account = useAppSelector(selectSelectedAccount);
  const [, { isSuccess: isAuthenticated }] = useFetchTokenMutation();
  const { data: partners } = useGetPartnersQuery(undefined, { skip: !isAuthenticated });
  const partner = account && partners ? PartnerUtils.getPartnerById(partners, account.partnerId) : undefined;

  return (
    <StyledFooter>
      <FooterCustomerInformation />
      <StyledLogoAndLinksContainer>
        <PartnerLogo partner={partner} />
        <StyledLinks>
          <FooterExternalLink label={i18n.component.footer.linkToCustomerService} url={config.CUSTOMER_SERVICE} />
          <FooterExternalLink label={i18n.component.footer.linkToMainPage} url={config.MAIN_PAGE} />
          {partner?.siteUrl && <FooterExternalLink label={partner.name} url={partner.siteUrl} />}
        </StyledLinks>
      </StyledLogoAndLinksContainer>
    </StyledFooter>
  );
};

export { Footer };
